export enum NotificationType {
  'Friendship.Received' = 'Friendship.Received',
  'Friendship.Accepted' = 'Friendship.Accepted',
  'UserFollow.Followed' = 'UserFollow.Followed',
  'PostReaction.Liked' = 'PostReaction.Liked',
  'PostComment.New' = 'PostComment.New',
}
